import { ALL_PERMISSIONS } from "./constants";

const PERMISSION_LABELS = {
  homepage: "Homepage Editor",
  portfolio: "Portfolio Management",
  users: "Customer Management",
  bookings: "Booking Management",
  sessions: "Session Calendar",
  services: "Service Management",
  showcase: "Showcase Editor",
  "studio-assistant": "AI Assistant",
  "privacy-terms": "Privacy & Terms",
};

export function permissionLabel(key) {
  return PERMISSION_LABELS[key] || key;
}

export function hasPermission(user, permission) {
  const isSuperadmin =
    user?.is_superadmin === true ||
    user?.is_superadmin === 1 ||
    user?.is_superadmin === "1";
  if (isSuperadmin) return true;

  const permissions = Array.isArray(user?.linked_permissions)
    ? user.linked_permissions
    : [];
  return permissions.includes("*") || permissions.includes(permission);
}

const allowed = new Set(ALL_PERMISSIONS.map((p) => p.key));

export function sanitizePermissions(list = []) {
  return Array.from(new Set(
    (Array.isArray(list) ? list : []).filter((permission) => allowed.has(permission))
  ));
}